import {Subscription} from 'rxjs';

interface AutoUnsubscribeConfig {
  componentAlias?: string;
  enableDebug?: boolean;
}

export function AutoUnsubscribe(config?: AutoUnsubscribeConfig) {
  return (target: any) => {
    const componentName = config?.componentAlias ?? target.name ?? 'unknown';
    // Per-INSTANCE accumulator. The previous closure-level `Subscription` was shared
    // by every instance of the class, and the setter self-added its argument
    // (`sub.add(sub)`, the param shadowing the closure) so nothing was ever tracked —
    // every `this.sub = x.subscribe()` leaked. Key the bag off the instance instead.
    const subKey = Symbol(`${componentName}:autoUnsubscribe`);

    const subLog = function (str: string) {
      if (config?.enableDebug) {
        console.log(str);
      }
    }

    subLog(`${componentName}: INIT`);

    const getter = function (this: any): Subscription {
      subLog(`${componentName}: GET sub`);
      this[subKey] ??= new Subscription();
      return this[subKey];
    };
    const setter = function (this: any, subscription: Subscription) {
      subLog(`${componentName}: SET sub`);
      this[subKey] ??= new Subscription();
      this[subKey].add(subscription);
    };

    Object.defineProperty(target.prototype, 'sub', {
      get: getter,
      set: setter
    });

    const original = target.prototype.ngOnDestroy;
    target.prototype.ngOnDestroy = function () {
      subLog(`${componentName}: UNSUBSCRIBE!`);
      this[subKey]?.unsubscribe();
      original?.apply(this, arguments);
    };
  }
}
